import { useQuery } from '@tanstack/vue-query';
import { environmentQueries } from '@services/overig/queries/EnvironmentQueries';
import { computed, type ComputedRef } from 'vue';

type Toggle =
  | 'GerelateerdeAdressenOptiesPerStraatWeergevenToggle'
  | 'InstellingenOverigMetDkimInfoInVueToggle'
  | 'MaatwerkdossierToggle'
  | 'MaatwerkV2DekkingsgebiedToggle'
  | 'PolistekstOokInvulbaarInRichTextEditorToggle'
  | 'VerzekerdBedragVeldLabelInregelbaarViaBeheerboxToggle'
  | 'StagedDocumentenToggle'
  | 'BerekenenFilterMaatschappijToggle'
  | 'TakensysteemWeergaveToggle'
  | 'PortefeuilleDashboardToggle'
  | 'NieuweGradatieTekstenToggle'
  | 'ActievePolissenEndpointVerbeterdToggle'
  | 'InstellingenVueZijmenuToggle'
  | 'HoedanighedenControleViaManagementToggle';

export function useFeatureToggle(toggle: Toggle): ComputedRef<boolean | undefined> {
  const env = useQuery({
    ...environmentQueries.get(),
    select: (res) => res.data.featureFlags,
    staleTime: 60 * 1000,
    retry: 10,
  });
  return computed(() => env.data?.value?.[toggle]);
}
